module.exports = __webpack_public_path__ + "images/diagram-containment.svg";